import { isInViewport } from '@common/utils/dom';
import { getDeviceType, isSafari } from '@common/utils/platform';

const headerClass = 'header';
const navItemClass = `${headerClass}__internal-links`;
const navItemActiveClass = `${headerClass}__internal-links--active`;
const internalHeaderClass = `${headerClass}__nav-internal-bottom`;
const mobileInternalHeaderClass = `${headerClass}__nav-internal-mobile`;
const headerProfileClass = `${headerClass}__profile`;
const profileDropdownClass = `${headerClass}__profile-dropdown`;

const internalHeaderEl = document.querySelector(`.${internalHeaderClass}`);
const headerProfile = document.querySelector(`.${headerProfileClass}`);
const profileDropdown = document.querySelector(`.${profileDropdownClass}`);
const headerProfileArrow = document.querySelector(
  `.${headerProfileClass}-arrow`,
);
const headerProfileSelectedIcon = document.querySelector(
  `.${headerProfileClass}-selected-icon`,
);
const headerProfileIcon = document.querySelector(
  `.${headerProfileClass}-icon`,
);
const mobileInternalHeader = document.querySelector(
  `.${mobileInternalHeaderClass}`,
);
const navbarBg = internalHeaderEl?.querySelector(
  `.${headerClass}__nav-internal-bg`,
);

function addClassToElement(ele, className) {
  if (!ele?.classList.contains(className)) { ele?.classList.add(className); }
}

function removeClassFromElement(ele, className) {
  if (ele?.classList.contains(className)) ele?.classList.remove(className);
}

function addBackground(navbarItem) {
  const internalHeaderWrapper = internalHeaderEl?.querySelector(
    `.${headerClass}__nav-internal`,
  );
  const internalHeaderProps = internalHeaderWrapper?.getBoundingClientRect();
  const navbarProps = navbarItem?.getBoundingClientRect();

  if (navbarBg) {
    navbarBg.style.width = `${navbarProps.width}px`;
    navbarBg.style.height = `${navbarProps.height}px`;
    navbarBg.style.transform = `translateX(
    ${navbarProps.left - internalHeaderProps.left}px
    )`;
  }
}

function handleProfileClick() {
  headerProfile?.addEventListener('click', () => {
    if (profileDropdown?.classList.contains('hidden')) {
      removeClassFromElement(profileDropdown, 'hidden');
    } else {
      addClassToElement(profileDropdown, 'hidden');
    }

    if (headerProfileArrow?.classList.contains('icon-chevron-up')) {
      removeClassFromElement(headerProfileArrow, 'icon-chevron-up');
      addClassToElement(headerProfileArrow, 'icon-chevron-down');
    } else {
      removeClassFromElement(headerProfileArrow, 'icon-chevron-down');
      addClassToElement(headerProfileArrow, 'icon-chevron-up');
    }

    if (headerProfileSelectedIcon?.classList.contains('hidden')) {
      removeClassFromElement(headerProfileSelectedIcon, 'hidden');
      addClassToElement(headerProfileIcon, 'hidden');
    } else {
      removeClassFromElement(headerProfileIcon, 'hidden');
      addClassToElement(headerProfileSelectedIcon, 'hidden');
    }
  });
}

function handleScrolling(parentNavbarClass) {
  const offsetTop = window.innerHeight - 420;
  let activeSectionId;

  const navItemsEl = parentNavbarClass?.querySelectorAll(`.${navItemClass}`);

  navItemsEl?.forEach((item) => {
    const sectionId = item.getAttribute('href');
    if (sectionId.startsWith('#') && isInViewport(sectionId, offsetTop)) {
      activeSectionId = sectionId;
    }
  });

  if (activeSectionId) {
    navItemsEl.forEach((el) => {
      removeClassFromElement(el, navItemActiveClass);
    });

    const activeNavbarEl = parentNavbarClass?.querySelector(
      `.header__internal-links[href='${activeSectionId}']`,
    );
    addClassToElement(activeNavbarEl, navItemActiveClass);
    addBackground(activeNavbarEl);

    let scrollOptions = {
      behavior: 'smooth',
      inline: 'center',
    };
    // scrollIntoView "with options" doesn't work in Safari
    if (isSafari()) {
      scrollOptions = true;
    }
    activeNavbarEl?.scrollIntoView(scrollOptions);
  }
}

function initialize() {
  handleProfileClick();
  if (getDeviceType() === 'desktop') {
    // Highlight first nav item
    // It's a fallback
    const firstNavItem = internalHeaderEl?.querySelector(`.${navItemClass}`);
    addClassToElement(firstNavItem, navItemActiveClass);
    addBackground(firstNavItem);

    // Initalize it once
    // so that whichever section
    // the user is currently gets highlighted
    handleScrolling(internalHeaderEl);

    // add scroll event listener on document
    document.addEventListener('scroll', () => {
      handleScrolling(internalHeaderEl);
    });
  } else {
    const firstNavMobileItem = mobileInternalHeader?.querySelector(
      `.${navItemClass}`,
    );
    addClassToElement(firstNavMobileItem, navItemActiveClass);

    // Initalize it once
    // so that whichever section
    // the user is currently gets highlighted
    handleScrolling(mobileInternalHeader);

    // add scroll event listener on document
    document.addEventListener('scroll', () => {
      handleScrolling(mobileInternalHeader);
    });
  }
}

export default { initialize };
